// Путь: D:\QR\QR-WEB\dashboard\src\components\Admin\AdminDary\AdminDaryReferrals.jsx
// Название: Admin DARY Referrals Management
// Версия: 1.0.0
// Дата: 28.01.2026

import React, { useState, useEffect } from 'react';
import './AdminDaryUniversal.css';

const API_URL = 'https://qr-money.onrender.com/api';

const AdminDaryReferrals = () => {
  const [referrals, setReferrals] = useState([]);
  const [archivedReferrals, setArchivedReferrals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('dary');
  const [statusFilter, setStatusFilter] = useState('all');
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({ total: 0, pages: 1 });
  const [message, setMessage] = useState(null);

  const token = localStorage.getItem('authToken');

  useEffect(() => {
    if (activeTab === 'dary') {
      loadDaryReferrals();
    } else {
      loadArchivedReferrals();
    }
  }, [activeTab, statusFilter, page]);

  const loadDaryReferrals = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams({ page, limit: 30, status: statusFilter });
      const res = await fetch(`${API_URL}/admin/dary/referrals?${params}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) {
        setReferrals(data.data.referrals);
        setPagination(data.data.pagination);
      }
    } catch (err) {
      console.error('Load referrals error:', err);
    } finally {
      setLoading(false);
    }
  };

  const loadArchivedReferrals = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams({ page, limit: 30, status: statusFilter });
      const res = await fetch(`${API_URL}/admin/dary/archived-referrals?${params}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) {
        setArchivedReferrals(data.data.referrals);
        setPagination(data.data.pagination);
      }
    } catch (err) {
      console.error('Load archived referrals error:', err);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('ru-RU', {
      day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
    });
  };

  const getStatusLabel = (status) => {
    const labels = {
      'ready': '✅ Готов',
      'activated': '🎉 Активирован',
      'archived_brand': '📦 Archived',
      'expired': '❌ Истёк'
    };
    return labels[status] || status;
  };

  const currentData = activeTab === 'dary' ? referrals : archivedReferrals;

  return (
    <div className="adu-page">
      {/* Header */}
      <div className="adu-header">
        <h1>🔗 DARY Рефералы</h1>
        <p>Управление реферальными ссылками DARY Universal</p>
      </div>

      {/* Message */}
      {message && (
        <div className={`adu-message adu-message-${message.type}`}>
          {message.text}
          <button onClick={() => setMessage(null)}>✕</button>
        </div>
      )}

      {/* Tabs */}
      <div className="adu-tabs">
        <button 
          className={`adu-tab ${activeTab === 'dary' ? 'active' : ''}`}
          onClick={() => { setActiveTab('dary'); setPage(1); setStatusFilter('all'); }}
        >
          🎁 DARY Рефералы
        </button>
        <button 
          className={`adu-tab ${activeTab === 'archived' ? 'active' : ''}`}
          onClick={() => { setActiveTab('archived'); setPage(1); setStatusFilter('all'); }}
        >
          📦 Archived Brand
        </button>
      </div>

      {/* Filters */}
      <div className="adu-controls">
        <div className="adu-filter-group">
          <label>Статус:</label>
          <select 
            value={statusFilter} 
            onChange={(e) => { setStatusFilter(e.target.value); setPage(1); }}
          >
            <option value="all">Все</option>
            <option value="ready">Готовые</option>
            <option value="activated">Активированные</option>
            {activeTab === 'archived' && (
              <option value="archived_brand">Archived Brand</option>
            )}
          </select>
        </div>
        
        <div className="adu-stats-mini">
          <span>Всего: <strong>{pagination.total}</strong></span>
        </div>
      </div>

      {/* Table */}
      {loading ? (
        <div className="adu-loading">Загрузка...</div>
      ) : (
        <>
          <div className="adu-table-wrapper">
            <table className="adu-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Код</th>
                  <th>Создатель</th>
                  {activeTab === 'archived' && <th>Бренд</th>}
                  {activeTab === 'archived' && <th>Кампания</th>}
                  <th>Статус</th>
                  <th>Активировал</th>
                  <th>Создан</th>
                  <th>Активирован</th>
                </tr>
              </thead>
              <tbody>
                {currentData.map(ref => (
                  <tr key={ref.id}>
                    <td>#{ref.id}</td>
                    <td>
                      <span className="adu-code">{ref.short_code}</span>
                    </td>
                    <td>
                      <div className="adu-user-cell">
                        <span>{ref.creator_email}</span>
                        {ref.creator_name && (
                          <small>{ref.creator_name}</small>
                        )}
                      </div>
                    </td>
                    {activeTab === 'archived' && (
                      <td>
                        <span className="adu-brand-cell">
                          {ref.logo_emoji} {ref.brand_name}
                        </span>
                      </td>
                    )}
                    {activeTab === 'archived' && (
                      <td>{ref.campaign_name}</td>
                    )}
                    <td>
                      <span className={`adu-status-badge adu-status-${ref.status}`}>
                        {getStatusLabel(ref.status)}
                      </span>
                    </td>
                    <td>{ref.activated_by_email || '-'}</td>
                    <td>{formatDate(ref.created_at)}</td>
                    <td>{formatDate(ref.activated_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Empty State */}
          {currentData.length === 0 && (
            <div className="adu-empty">
              <span>📭</span>
              <p>Нет рефералов с выбранным фильтром</p>
            </div>
          )}

          {/* Pagination */}
          {pagination.pages > 1 && (
            <div className="adu-pagination">
              <button 
                disabled={page <= 1}
                onClick={() => setPage(p => p - 1)}
              >
                ← Назад
              </button>
              <span>Страница {page} из {pagination.pages} (всего {pagination.total})</span>
              <button 
                disabled={page >= pagination.pages}
                onClick={() => setPage(p => p + 1)}
              >
                Вперёд →
              </button>
            </div>
          )}
        </>
      )}

      {/* Info Block */}
      <div className="adu-info-block">
        <h4>ℹ️ Информация</h4>
        {activeTab === 'dary' ? (
          <ul>
            <li><strong>DARY Рефералы</strong> — созданы системой DARY Universal</li>
            <li>Создаются автоматически когда юзер активирует archived_brand реферал</li>
            <li>Каждый новый юзер получает 3 DARY реферала для распространения</li>
            <li>Срок действия: 1 год</li>
          </ul>
        ) : (
          <ul>
            <li><strong>Archived Brand</strong> — рефералы от завершённых кампаний брендов</li>
            <li>Когда кампания бренда завершается, рефералы переходят в статус archived_brand</li>
            <li>Они продолжают работать, но бонусы начисляются на DARY баланс</li>
            <li>Это обеспечивает вирусный рост без затрат для DARY</li>
          </ul>
        )}
      </div>
    </div>
  );
};

export default AdminDaryReferrals;